module.exports = __webpack_public_path__ + "img/home-dfk.dd4436a3.svg";